module.exports = __webpack_public_path__ + "img/testimonio-gamliel.47db07f0.png";